import React, { useState, useEffect } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";

import MCard from "components/Shared/MCard.tsx";
import { MSpinner } from "components/Shared";

const CaseIssueFields = (props) => {
  const [caseIssueOptions, setCaseIssueOptions] = useState(null);
  const [issueComments, setIssueComments] = useState([]);

  const { caseIssues, caseIssueComments, caseIssueTypes, updateIssues } = props;

  useEffect(() => {
    if (!caseIssueOptions) {
      setCaseIssueOptions(mapCaseIssues());
      setIssueComments(caseIssueComments);
    }
  }, []);

  const mapCaseIssues = () => {
    let issueGroups = [];
    caseIssueTypes.forEach(s => {
      if (!issueGroups[s.displayGroup]) {
        issueGroups[s.displayGroup] = [];
      }
      issueGroups[s.displayGroup].push({
        name: s.name,
        value: s.code,
        checked: caseIssues.some(p => p.code === s.code)
      });
    });
    return issueGroups;
  };

  const handleChange = (event, code, group) => {
    let issues = { ...caseIssueOptions };
    issues[group].filter(s => s.value === code)[0].checked = event.target.checked;
    setCaseIssueOptions(issues);
  };

  const commentsRequired = () => {
    for (const issue of Object.entries(caseIssueOptions)) {
      if (caseIssueOptions[issue[0]].some(s => s.checked)) {
        return true;
      }
    }
  };

  const getFields = () => {
    let issueGroups = [];
    for (let s in caseIssueOptions) {
      issueGroups.push(shapeIssueGroup(caseIssueOptions[s], s));
    }
    const caseIssueComments = (
      <div>
        <TextField
          variant="standard"
          label="Case Issue Comments"
          value={issueComments}
          onChange={e => setIssueComments(e.target.value)}
          required={commentsRequired()}
          multiline
          rows={3}
          fullWidth
          sx={{
            '& .MuiInputLabel-root': {
              fontSize: '12.5px',
              fontWeight: 400,
              fontFamily: 'Roboto, sans-serif'
            },
            '& .MuiInputBase-input': {
              fontSize: '14px',
              fontWeight: 700
            }
          }}
        />
      </div>);
    const caseIssueSave = (
      <div className={"save-control"}>
        <Button disabled={commentsRequired() && !issueComments.length} onClick={() => updateIssues(caseIssueOptions, issueComments)}>Save</Button>
      </div>
    );
    return (
      [{
        key: "issues", control: (
          <>
            {issueGroups}
            {caseIssueComments}
            {caseIssueSave}
          </>
        )
      }]
    );
  };

  const shapeIssueGroup = (issueGroup, groupName) => {
    return (
      <div key={groupName}>
        <div><b><u>{groupName}</u></b></div>
        <FormGroup row>
          {issueGroup.map(s => (
            <FormControlLabel
              key={s.value}
              control={
                <Checkbox
                  checked={s.checked}
                  onChange={event => handleChange(event, s.value, groupName)}
                  value={s.value}
                  color="primary"
                />
              }
              label={s.name}
            />
          ))}
        </FormGroup>
      </div>
    );
  };

  if (!caseIssueOptions) {
    return (<MSpinner />);
  }
  return (
    <MCard
      title="Case Issues"
      className="qa-case-issues"
      fields={getFields()}
    />
  );
};

CaseIssueFields.propTypes = {
  caseIssues: PropTypes.array,
  caseIssueComments: PropTypes.string,
  caseIssueTypes: PropTypes.array,
  updateIssues: PropTypes.func,
};

export default CaseIssueFields;